import { FC } from "react";
import { Button, Tooltip } from "@altimateai/lego";
import { RegenerateButton } from "../regenerateButton";
import { Stack } from "@altimateai/lego";
import { IconCopy } from "@tabler/icons-react";

interface MessageMenuProps {
  messageId: string;
  content: string;
}

export const ChatLastMessageActions: FC<MessageMenuProps> = ({
  messageId,
  content,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
    } catch (err) {
      console.error("Failed to copy message:", err);
    }
  };

  return (
    <Stack direction="row">
      <RegenerateButton messageId={messageId} />
      <Tooltip title={"Copy message"}>
        <Button
          variant="ghost"
          size="sm"
          className={"al-text-gray-500"}
          onClick={handleCopy}
          aria-label="Copy response"
        >
          <IconCopy aria-hidden="true" />
        </Button>
      </Tooltip>
    </Stack>
  );
};
